import { createContext, useContext } from 'react'
import { useFormularioOs } from '../hooks/useFormularioOs'
import { useAnalises } from '../hooks/useAnalises'

/**
 * Valor do context = retorno do useFormularioOs (campos/dados do form)
 * + o estado da metade "Análises" sob a chave `analises`.
 */
type FormOsContextValue = ReturnType<typeof useFormularioOs> & {
  analises: ReturnType<typeof useAnalises>
  /** Permissões da rotina de OS: controlam clonar/remover análise e remover ponto. */
  permissoes: { acesso?: number; alteracao?: number; inclusao?: number; exclusao?: number }
}

const FormOsContext = createContext<FormOsContextValue | null>(null)

interface FormOsProviderProps {
  value: FormOsContextValue
  children: React.ReactNode
}

export function FormOsProvider({ value, children }: FormOsProviderProps) {
  return <FormOsContext.Provider value={value}>{children}</FormOsContext.Provider>
}

/** Acessa o estado/ações do formulário de OS. Lança erro se usado fora do provider. */
export function useFormOsContext(): FormOsContextValue {
  const ctx = useContext(FormOsContext)
  if (!ctx) {
    throw new Error('useFormOsContext deve ser usado dentro de <FormOsProvider>')
  }
  return ctx
}
